import dynamic from 'next/dynamic'

import { createModal } from '@/components/modalize'

const LoginModal = dynamic(() => import('./root'))

export default LoginModal

export const show = createModal(LoginModal, { id: 'login' })
